export default __webpack_public_path__ + "static/media/thumbnail_RO_Web_Homepage_Banner_SLIDE-3.312c07bb.webp";